var _style, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrongLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.StrongLight-st0{fill:currentColor;}\r\n\t.StrongLight-st1{fill:none;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M3.5,7.1C1.6,7.1,0,5.5,0,3.5S1.6,0,3.5,0S7,1.6,7,3.5S5.5,7.1,3.5,7.1z M3.5,0.9C2,0.9,0.8,2.1,0.8,3.6 S2,6.3,3.5,6.3C5,6.2,6.2,5,6.2,3.5C6.2,2.1,5,0.9,3.5,0.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M20.5,7.1c-2,0-3.5-1.6-3.5-3.5S18.5,0,20.5,0S24,1.6,24,3.5S22.4,7.1,20.5,7.1z M20.5,0.9 c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7C23.1,2.1,21.9,0.9,20.5,0.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M3.5,24c-2,0-3.5-1.6-3.5-3.5S1.6,17,3.5,17S7,18.6,7,20.5S5.5,24,3.5,24z M3.5,17.8c-1.5,0-2.7,1.2-2.7,2.7 s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7S5,17.8,3.5,17.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M20.5,24c-2,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S22.4,24,20.5,24z M20.5,17.8 c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7C23.1,19,21.9,17.8,20.5,17.8z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "StrongLight-st1",
    x1: 6.8,
    y1: 3.5,
    x2: 17.2,
    y2: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "StrongLight-st1",
    x1: 6.8,
    y1: 20.5,
    x2: 17.2,
    y2: 20.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "StrongLight-st1",
    x1: 20.5,
    y1: 6.8,
    x2: 20.4,
    y2: 17.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "StrongLight-st1",
    x1: 3.5,
    y1: 6.5,
    x2: 3.5,
    y2: 17.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M7.9,10.5c0-0.2-0.1-0.3-0.3-0.3h-1c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h0.9C7.7,10.8,7.9,10.7,7.9,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M7.8,12.3l-0.9,0.5c-0.1,0.1-0.2,0.3-0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.2h0.1L8,12.9c0.1-0.1,0.2-0.3,0.1-0.4 C8.1,12.3,7.9,12.2,7.8,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M8.4,8.2L7.5,7.8c-0.1-0.1-0.3,0-0.4,0.1C7,8.1,7.1,8.2,7.3,8.3l0.9,0.4h0.1c0.1,0,0.2-0.1,0.3-0.2 C8.6,8.5,8.5,8.3,8.4,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M17.4,10.2h-0.9c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h0.9c0.2,0,0.3-0.1,0.3-0.3 C17.7,10.4,17.6,10.2,17.4,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M17.2,12.8l-0.9-0.5c-0.1-0.1-0.3,0-0.4,0.1s0,0.3,0.1,0.4l0.9,0.5H17c0.1,0,0.2-0.1,0.3-0.2 C17.4,13,17.3,12.8,17.2,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M16.8,8.3C16.9,8.2,17,8,16.9,7.9s-0.3-0.2-0.4-0.1l-0.9,0.4c-0.1,0.1-0.2,0.3-0.1,0.4 c0.1,0.1,0.2,0.2,0.3,0.2h0.1L16.8,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M12.8,15.7h-1.7c-0.2,0-0.3,0.1-0.3,0.3v0.8c0,0.4,0.3,0.7,0.7,0.7h0.8c0.4,0,0.7-0.3,0.7-0.7V16 C13,15.8,12.9,15.7,12.8,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "StrongLight-st0",
    d: "M12,7.9c-1.7,0-3.1,1.4-3.1,3.1c0,1.3,0.5,2,1,2.6c0.4,0.5,0.7,1,0.9,1.7c0,0.1,0.2,0.2,0.3,0.2h1.7 c0.1,0,0.3-0.1,0.3-0.2c0.1-0.7,0.5-1.2,0.9-1.7l0,0l-0.2-0.2l0.2,0.2c0.5-0.7,1-1.4,1-2.6C15.1,9.2,13.7,7.9,12,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongLight);
export default __webpack_public_path__ + "static/media/StrongLight.1efa767e9cd1845554520b7444ed08cb.svg";
export { ForwardRef as ReactComponent };